<template>
  <v-app-bar
    @scroll="$route.path === '/' ? handleScroll : ''"
    class="header-desktop"
    :class="[$route.path === '/' ? 'header-home' : 'header-view']"
    height="156px"
    fixed
  >
    <v-container class="py-0">
      <v-sheet
        width="100%"
        height="100%"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="d-block header-home-logotipo"
            height="105px"
          />
        </router-link>

        <div class="d-flex flex-column align-end">
          <div class="d-flex" v-if="social.length">
            <v-btn
              v-for="{ link, target, icon, size } in social"
              :key="link"
              color="transparent"
              :href="link"
              :target="target ? target : '_blank'"
              depressed
              small
              fab
            >
              <v-icon class="social-icon" :size="size">
                {{ icon }}
              </v-icon>
            </v-btn>
          </div>

          <div class="d-flex align-center" :class="{ 'mt-1': social.length }">
            <div>
              <div
                v-for="({ text, to }, keyMenu) in menu"
                :key="keyMenu"
                class="d-inline-flex"
              >
                <v-btn
                  class="
                    white--text
                    text-body-2 text-lg-body-1 text-none
                    font-weight-light
                    px-2 px-lg-3
                    py-5
                    nav-link
                  "
                  :to="to"
                  active-class="nav-link-active"
                  tile
                  depressed
                  text
                >
                  {{ text }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { menu } from "../../../config";
import { getSocial } from "../../../utils/getSocial";

export default {
  data: () => ({
    menu,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      const social = getSocial(this.informations);

      if (this.informations.email)
        social.push({
          text: "E-mail",
          link: `mailto:${this.informations.email}`,
          target: "_self",
          icon: "far fa-envelope",
          size: 18,
        });

      return social;
    },
  },
  methods: {
    handleScroll() {
      if (document.documentElement.scrollTop > 50)
        document
          .getElementsByTagName("body")[0]
          .classList.add("v-app-bar--is-active");
      else
        document
          .getElementsByTagName("body")[0]
          .classList.remove("v-app-bar--is-active");
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.header-home::v-deep {
  background: rgb(0, 0, 0);
  background: -moz-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 100%
  );
  background-color: transparent !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#000000",GradientType=1);
}

.header-view {
  background-color: var(--v-primary-base) !important;
}

.header-home,
.header-view {
  box-shadow: none !important;

  .header-home-logotipo {
    filter: brightness(0) invert(1);
    transition: height 0.1s linear;
  }

  .social-icon {
    color: #ffffff !important;
  }
}

.nav-link::v-deep {
  &:before {
    opacity: 0 !important;
  }
}
</style>

<style lang="scss">
.v-app-bar--is-active {
  .header-desktop {
    background: #ffffff !important;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
      0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
    filter: none;
    height: 100px !important;
    transition: height 0.1s linear;

    .v-toolbar__content {
      height: 100px !important;
      transition: height 0.1s linear;
    }

    .header-home-logotipo {
      filter: none;
      height: 80px;
    }

    .nav-link,
    .social-icon {
      color: var(--v-primary-base) !important;
    }
  }
}
</style>
